import { Injectable } from '@angular/core';
import { TpslRouteStates } from '../models/tpsl-route-states';

@Injectable()
export class TpslRouteStateProvider {
  private _state: TpslRouteStates;

  constructor() {
    if (!this._state) {
      this._state = new TpslRouteStates();
    }
  }

  /**
   * getCurrentState
   */
  public getCurrentState(): TpslRouteStates {
    return this._state;
  }

  /**
   * setState
   */
  public setState(newState: TpslRouteStates): void {
    if (!newState) {
      // console.log('Cannot set the state, new state object is empty');
      return;
    }

    this._state = newState;
  }

  /**
   * getIsRouteLocked
   */
  public getIsRouteLocked(routeId: number): boolean {
    // TODO : LOAD FROM LOCAL STORAGE - VIET
    return this._state.LockedRoute.has(routeId);
  }

  /**
   * setLockOnRoute
   */
  public setLockOnRoute(routeId: number, locked: boolean) {
    // TODO : SET TO LOCAL STORAGE - VIET
    if (locked) {
      this._state.LockedRoute.set(routeId, true);
    } else {
      this._state.LockedRoute.delete(routeId);
    }
  }


  /**
   * getIsRouteHidden
   */
  public getIsRouteHidden(routeId: number): boolean {
    // TODO : LOAD FROM LOCAL STORAGE - VIET
    return this._state.HiddenRoute.has(routeId);
  }

  /**
   * setHideRoute
   */
  public setHideRoute(routeId: number, hide: boolean) {
    // TODO : SET TO LOCAL STORAGE - VIET
    if (hide) {
      this._state.HiddenRoute.set(routeId, true);
    } else {
      this._state.HiddenRoute.delete(routeId);
    }
  }

  /**
   * canDisplayRoute
   */
  public canDisplayRoute(routeId: number) {
    return !this.getIsRouteHidden(routeId);
  }


  /**
   * setSelectedDate
   */
  public setSelectedDate(selectedDate: Date) {
    // TODO : SET TO LOCAL STORAGE - VIET
    if (selectedDate) {
      this._state.SelectedDate = selectedDate;
    }
  }

  /**
   * setSelectedSectorId
   */
  public setSelectedSectorId(selectedSectorId: number) {
    this._state.SelectedSectorID = selectedSectorId;
  }

  /**
   * setSelectedRouteId
   */
  public setSelectedRouteId(selectedRouteId: number) {
    this._state.SelectedRouteID = selectedRouteId;
  }
}


